import { TrackingStatus } from '@/constants';
import { getLabelFromValue, transformOptions } from '@/helpers';

export const trackingStatusOptions = transformOptions(TrackingStatus);

export const getTrackingStatusLabelByValue = (value: string) => getLabelFromValue(value, trackingStatusOptions);
